module.exports = __webpack_public_path__ + "img/263-5ce08e.png";